import { Component, inject, Input } from '@angular/core';
import { TranslationService } from '@services/translation.service';

@Component({
  selector: 'app-benefits-contact',
  standalone: true,
  imports: [],
  templateUrl: './benefits-contact.component.html',
  styleUrl: './benefits-contact.component.css'
})
export class BenefitsContactComponent {

  // INPUTS
  @Input({required: true}) public email!: string;

  @Input({required: true}) public phone!: string;

  public readonly translation: TranslationService = inject(TranslationService);
  

  
}
